export const MEMBER_CHANGE_DELAY = 1000

export const TASK_TYPE = {
  PENDING_EXCLUSION: 'pending_exclusion',
  PENDING_PRESCRIPTION: 'pending_prescription',
  FOLLOW_UP_PRESCRIPTION: 'follow_up_prescription',
  PENDING_REPLY: 'pending_reply',
  PLAN_OF_CARE: 'plan_of_care',
  PROBLEMATIC_REASSESSMENT: 'problematic_reassessment',
  PROBLEMATIC_SESSION: 'problematic_session',
  PROTOCOL_PROGRESSION: 'protocol_progression',
  GUTENBERG_REACH_OUT: 'gutenberg_reachouts',
  CLINICAL_REFERRAL_REJECTION: 'referral_rejection',
  UPCOMING_CALL: 'upcoming_call',
  ACADEMY_SUGGESTION: 'academy_suggestion',
  SESSION_DONE: 'session_done',
  PENDING_RESISTANCE_PRESCRIPTION: 'pending_resistance_prescription',
  REACH_OUT: 'gutenberg_reachouts_v2',
  PENDING_PRESCRIPTION_V2: 'pending_prescription_v2',
} as const

export const NO_DATA_PAYLOAD_REQUIRED_SUBTASKS = Object.freeze([
  TASK_TYPE.PENDING_PRESCRIPTION,
  TASK_TYPE.PENDING_REPLY,
  TASK_TYPE.FOLLOW_UP_PRESCRIPTION,
  TASK_TYPE.PENDING_RESISTANCE_PRESCRIPTION,
] as const)

export const TASK_TYPE_ORDER = {
  DEFAULT_ORDER: -1,
  [TASK_TYPE.PENDING_REPLY]: 1, // Bottom of the list
}

export const TASK_ACTION_TYPE = {
  NOT_RELEVANT: 'not_relevant',
  MESSAGE_SENT: 'message_sent',
  MARK_AS_DONE: 'mark-as-done',
  CALL_DONE: 'call_done',
  CALL_RESCHEDULE: 'call_reschedule',
  NO_SHOW: 'no_show',
  REJECT: 'reject',
  ACCEPT: 'accept',
} as const

export const RESOLUTION_TYPE = {
  DONE: 'done',
  DISMISS: 'dismiss',
}

export const SUPPORTED_REACH_OUT_TYPES = ['chat', 'phone', 'sms', 'voicemail']

export const MORE_OPTIONS = {
  PRESCRIPTIONS: 'prescriptions',
  RESULTS: 'results',
  RECORDS: 'records',
  PROFILE: 'profile',
}

export const KEY_DAYS_OF_WEEK = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

export const QUERY_KEYS_CONTEXT = {
  SUMMARY: 'ai-feed-feed-program-summary',
  CHART: 'ai-feed-feed-program-chart',
  MASTER_TASK: 'ai-feed-master-task',
  UPDATES: 'ai-feed-updates-list',
  BANNER: 'ai-feed-member-banner',
}

export const PRE_FETCH_QUERY_KEYS_CONTEXT = {
  SUMMARY: { KEY: QUERY_KEYS_CONTEXT.SUMMARY, ENDPOINT: 'aiFeed/fetchFeedProgramSummary' },
  CHART: { KEY: QUERY_KEYS_CONTEXT.CHART, ENDPOINT: 'aiFeed/fetchFeedProgramChart' },
  BANNER: { KEY: QUERY_KEYS_CONTEXT.BANNER, ENDPOINT: 'aiFeed/fetchFeedProgramBanner' },
  MASTER_TASK: { KEY: QUERY_KEYS_CONTEXT.MASTER_TASK, ENDPOINT: 'aiFeed/fetchMasterTask' },
}

export const CV_IN_APP_MODES = {
  HYBRID: 'hybrid',
  APP: 'app',
  PAD: 'pad',
}

export const ALERTS_ICON_MAP = {
  red_flags: 'flag',
  surgery: 'surgery',
  mental_health: 'mind',
  cancer: 'cancer',
  active_medication: 'pill',
  pregnancy: 'pregnancy',
  postpartum: 'baby',
  high_risk: 'bolt',
  // Units
  thrive: 'thrive_unit',
  mind: 'mind_unit',
  bloom: 'bloom_unit',
  move: 'move_unit',
} as const
